import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-edit-role-confirmation',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './edit-role-confirmation.component.html',
  styleUrls: ['./edit-role-confirmation.component.scss', '../../../app.component.scss', '../../../shared/base-modal.style.scss']
})
export class EditRoleConfirmationComponent {
  public dialogData: any;

  constructor(
    public dialogRef: MatDialogRef<EditRoleConfirmationComponent>,
    public dialog: MatDialog,
    public router: Router,

    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if(data){
      this.dialogData = data;
    }
  }

  onClose(): void {
    this.dialogRef.close();
    this.router.navigateByUrl('roles');
  }

  confirm(): void {
    this.dialogRef.close(true);
    this.router.navigateByUrl('roles');
  }

  redirectToUsers(){
    this.dialogRef.close();
    this.router.navigateByUrl("users");
  }
}
